import { createFileRoute } from "@tanstack/react-router";

import ResetPasswordPage from "@/features/auth/pages/reset-password";

interface ResetPasswordSearchParams {
  // Token arrives from the backend reset email: <appBaseUrl>/auth/reset-password?token=...
  token?: string;
}

export const Route = createFileRoute("/(auth)/reset-password")({
  component: () => (
    <main role="main" aria-label="Reset password page" className="min-h-screen w-full">
      <ResetPasswordPage />
    </main>
  ),
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearchParams => ({
    token: search.token as string | undefined,
  }),
});
